export default "__VITE_ASSET__BEueWxOy__"